// import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../interceptors/axios";

// export const getPaypalPlans = createAsyncThunk("getPaypalPlans", async () => {
//   try {
//     const {
//       data: {
//         data: { plans },
//       },
//     } = await api.get("/api/v3/paypalPayments/plans");

//     return plans
//       .sort((plan) => (plan.interval === "MONTH" ? 1 : -1))
//       .map((plan) => ({
//         id: plan.id,
//         name: plan.name,
//         price: plan.price,
//         priceFormatted: plan.description,
//         billingCycle: plan.interval.toLowerCase(),
//         description: `$${plan.price}`,
//         isPopular: plan.interval !== "MONTH",
//       }));
//   } catch (error) {
//     console.error("Error getting PayPal plans:", error);
//   }
// });

export const createPaypalCheckoutSession = async (planId) => {
  try {
    const {
      data: { data },
    } = await api.post("/api/v3/paypalPayments/subscriptions/sessions", {
      planId,
    });

    // Get the URL to which the user should be redirected
    const { approvalUrl } = data;

    // Redirect the user to PayPal's checkout page
    window.location.href = approvalUrl;
  } catch (error) {
    console.error("Error creating PayPal subscription session:", error);
    throw error;
  }
};

// export const changePlanOfSubscription = async (subscriptionId, newPlanId) => {
//   try {
//     const {
//       data: { data },
//     } = await api.put("/api/v3/paypalPayments/subscriptions", {
//       subscriptionId,
//       planId: newPlanId,
//     });

//     return data;
//   } catch (error) {
//     console.error("Error change plan of subscription", error);
//     throw error;
//   }
// };

// export const checkSubscriptionStatus = createAsyncThunk(
//   "checkSubscription",
//   async () => {
//     try {
//       const {
//         data: { data },
//       } = await api.get("/api/v3/paypalPayments/subscriptions/status");

//       return data;
//     } catch (error) {
//       console.error("Error check subscription status:", error);
//       throw error;
//     }
//   }
// );

// export const getSubscriptionById = async (subscriptionId) => {
//   try {
//     const {
//       data: { data },
//     } = await api.get(`/api/v3/paypalPayments/subscriptions/${subscriptionId}`);

//     return data;
//   } catch (error) {
//     console.error("Error get subscription by ID:", error);
//     throw error;
//   }
// };

// export const cancelSubscriptionById = async (subscriptionId) => {
//   try {
//     const {
//       data: { data },
//     } = await api.post("/api/v3/paypalPayments/subscriptions/cancel", {
//       subscriptionId,
//     });

//     return data;
//   } catch (error) {
//     console.error("Error cancel subscription:", error);
//     throw error;
//   }
// };
